import React from 'react'
import { ContainedButton } from 'irmlib/components/Controls/Button'
import { getUser } from '../../redux/global'
import { Typography, Dialog } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import * as routePaths from '../../navigation/routePaths'
// import { Dialog } from '@material-ui/core'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { useHistory, useLocation } from 'react-router-dom'


const RestrictImage = (props) => {
  const { t } = useTranslation()
  const roleOfUser = getUser()?.userRolesObj?.gdeRole
  const history = useHistory()
  const location = useLocation()
  const isLocalQualityCheck = location.pathname.startsWith(routePaths.localQualityCheck)

  const goToDashboard = () => {
    switch (roleOfUser) {
      case 'Admin': {
        history.push(`${routePaths.localSmartCatalogDashboard}`)
        break
      }
      case 'Supervisor': {
        history.push(`${routePaths.localSmartCatalogDashboard}`)
        break
      }
      case 'Data Entry': {
        history.push(`${routePaths.localSmartCatalogDashboard}`)
        break
      }
      case 'Super User': {
        history.push(`${routePaths.localSmartCatalogDashboard}`)
        break
      }
      default: {
        history.push(`${routePaths.localSmartCatalogDashboard}`)
      }
    }
  }

  return (
    <>
      <React.Fragment>
        <Dialog open={true} fullWidth maxWidth='md'>
          <DialogTitle>{t('dataEntry.alert')}</DialogTitle>
          <DialogContent>
            <Typography variant='h3' style={{ padding: '1rem', fontSize: '25px', textAlign: 'center' }} > {isLocalQualityCheck ? t('smartCatalogLocal.localQualityCheckMessage') : t('smartCatalog.tabClosing')}</Typography>
          </DialogContent>
          <DialogActions sx={{ pb: 2, pr: 2 }}>
            <ContainedButton
              style={{ width: '250px', height: '36.5px', margin: '5px' }}
              onClick={goToDashboard}
            >
              {t('smartCatalog.smartCatalogLocalDashBoard').toUpperCase()}
            </ContainedButton>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </>
  )
}

export default RestrictImage